import './Page.css';
import CopyBlock from './CopyBlock';

export default function About() {
  return (
    <div className='page'>
      <h2 className='subheadline-black'>Materiały dla mediów</h2>
      <div className='page-text with-icons'>
        <h3 className='headline-before-copy'>Pliki do pobrania:</h3>
        <div>
          <img className='ikona-modal' src='./img/ikona-pobranie.svg' />
          <a href={`${process.env.PUBLIC_URL}/files/logo.zip`}>
            Logo otwarte pracownie w różnych wersjach
          </a>
        </div>
        <div>
          <img className='ikona-modal' src='./img/ikona-pobranie.svg' />
          <a
            href={`${process.env.PUBLIC_URL}/files/edycja-2025/pliki-online.zip`}
          >
            Pliki na potrzeby online
          </a>
        </div>
        <div>
          <img className='ikona-modal' src='./img/ikona-pobranie.svg' />
          <a
            href={`${process.env.PUBLIC_URL}/files/edycja-2025/pliki-do-druku.zip`}
          >
            Pliki do druku
          </a>
        </div>
</div>
        <h3 className='headline-before-copy'>Notatki prasowe:</h3>
        <div className='page-text'>
          <CopyBlock
            copyText={`Wrażliwe Mazury, wędruj z pasją!
    W dniach 11-13 lipca Stowarzyszenie Nasze Talki zaprasza na trzecią edycję akcji „Otwarte Pracownie na Mazurach 2025”, kulturalnej inicjatywy, która otwiera drzwi do 40 mazurskich pracowni, galerii i warsztatów. Wydarzenie promuje kontakt z naturą, sztuką i społecznością lokalną, oferując autentyczne doświadczenia w sercu Mazur. Mapa artystycznych Mazur jest dostępna na stronie www.otwartepracownie.com i w wersji papierowej. Warto wiedzieć, że artystów można odwiedzać cały rok, bo piękno pejzażu i duszy przyciąga nie tylko latem.
    Akcja ma charakter non-profit, a jej celem jest wspieranie lokalnej kultury, promowanie twórczości i integracja środowisk wiejskich i turystycznych.`}
          >
            <>
              <h3>Wrażliwe Mazury, wędruj z pasją!</h3>
              <p>
                W dniach 11-13 lipca Stowarzyszenie Nasze Talki zaprasza na
                trzecią edycję akcji „Otwarte Pracownie na Mazurach 2025”,
                kulturalnej inicjatywy, która otwiera drzwi do 40 mazurskich
                pracowni, galerii i warsztatów. Wydarzenie promuje kontakt z
                naturą, sztuką i społecznością lokalną, oferując autentyczne
                doświadczenia w sercu Mazur. Mapa artystycznych Mazur jest
                dostępna na stronie www.otwartepracownie.com i w wersji
                papierowej. Warto wiedzieć, że artystów można odwiedzać cały
                rok, bo piękno pejzażu i duszy przyciąga nie tylko latem.
              </p>
              <p>
                Akcja ma charakter non-profit, a jej celem jest wspieranie
                lokalnej kultury, promowanie twórczości i integracja środowisk
                wiejskich i turystycznych.
              </p>
            </>
          </CopyBlock>
        </div>
        <div className='page-text'>
          <h3 className='headline-before-copy'>Więcej informacji:</h3>
          <CopyBlock
            copyText={`Stowarzyszenie Nasze Talki
            Telefon: 784 231 053
            E-mail: grafelinska@gmail.com
            Strona WWW: http://naszetalki.pl
            Facebook: StowarzyszenieNaszeTalki
            Adres: Talki 51, 11-510 Wydminy
            Nr konta: 43 2030 0045 1110 0000 0395 4700`}
          >
            <div className='page-text with-icons'>
              <p>Stowarzyszenie Nasze Talki</p>

              <div>
                <img className='ikona-modal' src='./img/ikona-tel.svg' />
                784 231 053
              </div>
              <div>
                <img className='ikona-modal' src='./img/ikona-mail.svg' />{' '}
                grafelinska@gmail.com
              </div>
              <div>
                <img className='ikona-modal' src='./img/ikona-site.svg' />{' '}
                http://naszetalki.pl
              </div>
              <div>
                <img className='ikona-modal' src='./img/ikona-fb.svg' />{' '}
                StowarzyszenieNaszeTalki
              </div>
              <div>
                <img className='ikona-modal' src='./img/ikona-adress.svg' />{' '}
                Talki 51, 11-510 Wydminy
              </div>
              <div>Nr konta: 43 2030 0045 1110 0000 0395 4700</div>
            </div>
          </CopyBlock>
        </div>

        <div className='page-text'>
          <CopyBlock
            copyText={` WSPÓLNOTA   KULTURA   SZTUKA I EDUKACJA   EKOLOGIA
            Stowarzyszenie „Nasze Talki” to organizacja pozarządowa, działająca na terenie mazurskiej wsi Talki, położonej w gminie Wydminy (pow. giżycki). Od 2008 roku wspólnie chronimy krajobraz, integrujemy lokalną społeczność, organizujemy wydarzenia kulturalne. Naszą misją jest wspieranie zrównoważonego rozwoju otoczenia bliskiego naszemu sercu. Chcemy by wieś Talki i całe Mazury były miejscem dobrym do życia, aktywnym i otwartym, przyjaznym ludziom i naturze.`}
          >
            <h3 className='headline-before-copy'>
              WSPÓLNOTA &#x2022; KULTURA &#x2022; SZTUKA &#x2022; EDUKACJA
              &#x2022; EKOLOGIA
            </h3>
            <p>
              Stowarzyszenie „Nasze Talki” to organizacja pozarządowa,
              działająca na terenie mazurskiej wsi Talki, położonej w gminie
              Wydminy (pow. giżycki). Od 2008 roku wspólnie chronimy krajobraz,
              integrujemy lokalną społeczność, organizujemy wydarzenia
              kulturalne. Naszą misją jest wspieranie zrównoważonego rozwoju
              otoczenia bliskiego naszemu sercu. Chcemy by wieś Talki i całe
              Mazury były miejscem dobrym do życia, aktywnym i otwartym,
              przyjaznym ludziom i naturze.
            </p>
          </CopyBlock>
        </div>
      </div>
    
  );
}
